import type {
  SitesTemplateInfernoMicrositeSocial,
  SitesTemplateInfernoSiteSocial,
} from "@ihr-radioedit/inferno-webapi";
import { ILog } from "@ihr-radioedit/inferno-core";
const log = ILog.logger("social.lib");

const SWITCH_SUFFIX = "_switch";

export interface SocialNetworkData {
  network: string;
  username: string;
}

export function socialConfigAbstract(
  socialConfig?: SitesTemplateInfernoSiteSocial | SitesTemplateInfernoMicrositeSocial | null,
) {
  if (!socialConfig) {
    return [];
  }

  const networks: SocialNetworkData[] = [];
  for (const [key, value] of Object.entries(socialConfig)) {
    if (!value || !key.endsWith(SWITCH_SUFFIX)) {
      continue;
    }
    const network = key.slice(0, -SWITCH_SUFFIX.length);
    const configRecord = socialConfig as Record<string, string | boolean | null | undefined>;
    const username = configRecord[`${network}_name`];
    if (!username || typeof username !== "string") {
      continue;
    }
    networks.push({ network, username });
  }
  return networks;
}

export type ShareData = {
  title?: string;
  text?: string;
  url?: string;
};

export const nativeShare = (data: ShareData) => {
  log.debug("data = ", data);
  if (!navigator.share) {
    return;
  }
  try {
    navigator
      .share(data)
      .then(() => {
        log.debug("share worked?");
      })
      .catch(error => {
        log.debug("share error", error);
      });
  } catch (e) {
    log.error("native sharing failed", e.message);
  }
};
